import { parse } from 'node-html-parser';

export class HtmlParser {
  /**
   * 引数に与えられたHTMLのテキストを解析して、画像またはリンクのURLを第二引数で指定されたマッピングに従って置き換える。
   * @param html HTMLのテキスト
   * @param urlMap key-value 形式の新旧URL対応表
   * @returns
   */
  static replaceUrls(html: string, urlMap: Record<string, string>): string {
    if (!html) return html;

    const root = parse(html);
    const targetLinks = root.querySelectorAll('a');
    targetLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (href && urlMap[href]) {
        link.setAttribute('href', urlMap[href]);
      }
    });
    const targetImages = root.querySelectorAll('img');
    targetImages.forEach((img) => {
      const src = img.getAttribute('src');
      if (src && urlMap[src]) {
        img.setAttribute('src', urlMap[src]);
      }
    });

    return root.toString();
  }
}
